/**
 * Specifies the type of limit amount check being requested.
 * tag: 2323
 * @readonly
 * @enum {number} (int)
 */
export enum RiskLimitCheckRequestType {
  AllOrNone = 0,
  Partial = 1,
}
